import React from "react";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useLabels } from "../../hooks/useLabels";
import { useProductCategory } from "../../hooks/useProductCategory";
import { useProductCode } from "../../hooks/useProductCode";
import { showInfoDialogAsync } from "../dialogs/info-dialog";
import { FloatingMenuItem } from "./floating-menu-item";
import { labels, dynamicLabels } from "./labels";

export function InfoMenuItem() {
	const productCode = useProductCode();
	const productCategory = useProductCategory();
	const { createErrorHandler } = useErrorHandling();

	const [[info, infoMessageProduct, infoMessageProductCategory, infoContent], areLabelsLoading] =
		useLabels([
			labels.info,
			dynamicLabels.infoMessageProduct(productCode),
			dynamicLabels.infoMessageProductCategory(productCategory),
			labels.infoContent,
		]);

	function onInfoClick() {
		// infoMessage:First check for content in infoMessageProduct, then goto infoMessageProductCategory as fallback
		const infoMessage = infoMessageProduct || infoMessageProductCategory;
		// Remove the the link to a help dialog (this HTML code is the value of 'infoContent')
		// Remove leading breaks
		const infoMessageFiltered = infoMessage
			?.replace(infoContent ?? "", "")
			.replace(/<br\/>$/, "")
			.trim();

		if (!infoMessageFiltered) {
			return;
		}

		showInfoDialogAsync({
			messageHtml: infoMessageFiltered,
		}).catch(createErrorHandler());
	}

	if (areLabelsLoading || (!infoMessageProduct && !infoMessageProductCategory)) return null;

	return <FloatingMenuItem text={info} iconName="info" onClick={onInfoClick} />;
}
